// API
export { albumApi } from './api/album-service';
export { upscaleApi } from './api/upscale';
export type { UpscaleRenderResponse, RenderUpscaleStatus } from './api/upscale';
export type {
  AlbumGenerateRequest,
  AlbumCostPredictionParams,
  AlbumStatus,
  Album,
  ProjectAlbumsEntry,
} from './api/album-service';

// Hooks
export { useUpscaleProgress } from './hooks/use-upscale-progress';
export { useAlbum } from './hooks/use-album';
export { useAlbumCostPrediction } from './hooks/use-album-cost-prediction';
export { useAlbumEstimatePicker } from './hooks/use-album-estimate-picker';
export type { AlbumEstimatePicker } from './hooks/use-album-estimate-picker';
export { useAlbumDuplicatePrompt } from './hooks/use-album-duplicate-prompt';

// Model (stores)
export {
  useAlbumSettingsStore,
  useConceptAlbumSettings,
  PREMIUM_ALBUM_TEMPLATES,
  isPremiumAlbumTemplate,
} from './model/album-settings.store';
export type {
  AlbumTemplate,
  AlbumLanguage,
  AlbumMeasurementSystem,
} from './model/album-settings.store';
export {
  MATERIALS_SECTION_TOGGLE_ROW,
  SECONDARY_SECTION_TOGGLE_ROWS,
} from './model/album-section-toggles';
export type {
  AlbumSectionToggleKey,
  AlbumSectionToggleRow,
  AlbumSectionToggles,
} from './model/album-section-toggles';

// UI Components
export { AlbumCollapsiblePanel } from './ui/AlbumCollapsiblePanel';
export { AlbumEstimateOptions } from './ui/AlbumEstimateOptions';
export { AlbumRenderThumbnailStrip } from './ui/AlbumRenderThumbnailStrip';
export { AlbumDuplicateDialog } from './ui/AlbumDuplicateDialog';
export { AlbumLanguageSelector } from './ui/AlbumLanguageSelector';
export { UpscaleProgress } from './ui/UpscaleProgress';
export { AlbumListWithViewer } from './ui/AlbumListWithViewer';
export { ProjectAlbumsPage } from './ui/ProjectAlbumsPage';

// Lib
export { parseApiError } from './lib/error-utils';
export type { ErrorDetails } from './lib/error-utils';
